import calcRemainingLoanMonths from "../../../objects/AssetsExpenses/calc_remaining_loan_months";
import { findRemoveTableItem } from "../../../objects/AssetsExpenses/find_remove_table_item";
import { autoInsuranceCostCalcAmt } from "../../../objects/monthlyCalc/autoInsuranceCostCalc";
import { monthlyLoanAmt } from "../../../objects/AssetsExpenses/loanAmtCalc_function";

export const calculateNewMonthlyPayAmt = (tradeInAmt, currentCarTotalLoanAmt, 
        newLoanRequired, newCarLoanAmt, carLoanTerm, applyTradeIn, downPaymentAmt, currentCarMonthlyLoanAmt,
        currentCarLoanIntRate, expenseTable, noCar, newCarCost, newCarSize, currentGameDate,
        newLoanIntRate) => {

      let tradeInOption = false;
      let tradeInOptionText = ""; 
      if (+tradeInAmt >= +currentCarTotalLoanAmt && +tradeInAmt > 0 &&
         newLoanRequired === true ){
            tradeInOption = true;
            if (+currentCarTotalLoanAmt > 0){
                tradeInOptionText = "The trade-in value for your current car is greater than " +
                    "the outstanding loan amount. " 
            }
            tradeInOptionText += "You can choose to apply the trade-in amount to the loan for the " +  
                "new car which will reduce your monthly loan amount ...OR... you can apply the " +
                "trade-in amount to cash."
           
      }
      let loanMonthsRemaining = 0;
      let monthlyCarLoanAmt = 0;
      let addToCashAmt = 0;
      if (newCarLoanAmt > 0){
          let loanAmt = newCarLoanAmt;
          let nbrYears = carLoanTerm;
          let loanType = "car";
          monthlyCarLoanAmt = monthlyLoanAmt(loanAmt, newLoanIntRate, nbrYears, loanType);
      }else{
          if (tradeInOption === false){
            monthlyCarLoanAmt = 0;
            let validTradeInAmt = tradeInAmt;
            if (applyTradeIn === false){
                validTradeInAmt = 0;
            }
            const reducedLoanAmt = +currentCarTotalLoanAmt - +validTradeInAmt - +downPaymentAmt;
            if (reducedLoanAmt > 0){
                monthlyCarLoanAmt = currentCarMonthlyLoanAmt;
                loanMonthsRemaining = calcRemainingLoanMonths(reducedLoanAmt, 
                    currentCarMonthlyLoanAmt,
                    currentCarLoanIntRate);
                loanMonthsRemaining = loanMonthsRemaining.toFixed(0);
            }
          }else{
            monthlyCarLoanAmt = 0;
            addToCashAmt = +currentCarTotalLoanAmt - +tradeInAmt;
          }
      }
     
      let monthlyLoanDifferenceAmt = +monthlyCarLoanAmt - +currentCarMonthlyLoanAmt;
      const carInsObj = findRemoveTableItem(expenseTable,"carIns", false)
      const currentAutoInsAmt = carInsObj.expAmount;
      let currentCarBusPassAmt = 0;
      const busPassObj = findRemoveTableItem(expenseTable, "busPass", false);
      if (busPassObj.expAmount){
          currentCarBusPassAmt = busPassObj.expAmount;
      }
      let newAutoInsuranceObj = {};
      let newAutoInsuranceAmt = 0;

      if (noCar === false){
          newAutoInsuranceObj = autoInsuranceCostCalcAmt(newCarCost, newCarSize, 
            currentGameDate);
          newAutoInsuranceAmt = newAutoInsuranceObj.expAmount;
      }
      let monthlyAutoInsDiffAmt = +currentAutoInsAmt - +newAutoInsuranceAmt;
        
      const returnObj = {tradeInOption: tradeInOption, tradeInOptionText: tradeInOptionText,
            loanMonthsRemaining: loanMonthsRemaining, monthlyCarLoanAmt: monthlyCarLoanAmt,
            addToCashAmt: addToCashAmt,  currentAutoInsAmt: currentAutoInsAmt,
            currentCarBusPassAmt: currentCarBusPassAmt, newAutoInsuranceAmt: newAutoInsuranceAmt,
            newAutoInsuranceObj: newAutoInsuranceObj,
            monthlyAutoInsDiffAmt: monthlyAutoInsDiffAmt, monthlyLoanDifferenceAmt: monthlyLoanDifferenceAmt
      };
      return returnObj;
}
export default calculateNewMonthlyPayAmt;